import type { ReactNode } from 'react';

export function LearnPageFrame({
  children,
  navigation,
  banner,
  dock,
  immersive = false,
  fluid = false,
}: {
  children: ReactNode;
  navigation?: ReactNode;
  banner?: ReactNode;
  dock?: ReactNode;
  immersive?: boolean;
  fluid?: boolean;
}) {
  return (
    <div className="flex h-full flex-col bg-canvas" data-testid="learn-page-frame">
      {banner}
      {navigation}
      <main
        className={
          immersive
            ? 'min-h-0 flex-1 overflow-hidden'
            : `min-h-0 flex-1 overflow-y-auto ${dock ? 'pb-[calc(7rem+env(safe-area-inset-bottom))]' : ''}`
        }
      >
        {fluid ? (
          children
        ) : (
          <div
            className="mx-auto w-full max-w-[1440px] px-5 py-6 sm:px-7 md:py-7 xl:px-10 xl:py-8"
            data-testid="learn-content-frame"
          >
            {children}
          </div>
        )}
      </main>
      {dock}
    </div>
  );
}
